import React, { useState } from 'react';
import { RequetesAnalytics } from './RequetesAnalytics';
import { RequetesGerer } from './RequetesGerer';
import { RequetesConfigurer } from './RequetesConfigurer';
import { useLanguage } from '../contexts/LanguageContext';
import { useScreenInit } from '../useScreenInit.js';
interface RequetesModuleProps {
  /** Opens the module on a given sub-tab (e.g. from a release note). */
  initialSubTab?: 'gerer' | 'analytiques' | 'configurer';
}
export function RequetesModule({
  initialSubTab
}: RequetesModuleProps = {}) {
  const {
    t
  } = useLanguage();
  const screenInit = useScreenInit();
  const [activeSubTab, setActiveSubTab] = useState(initialSubTab ?? screenInit.activeSubTab ?? 'gerer');
  const tabs: {
    id: string;
    label: string;
  }[] = [{
    id: 'gerer',
    label: t('Gérer', 'Manage')
  }, {
    id: 'analytiques',
    label: t('Analytiques', 'Analytics')
  }, {
    id: 'configurer',
    label: t('Configurer', 'Configure')
  }];
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-6258" data-mp="2jjjenvpbz48f">
      {/* Page Title & Navigation */}
      <div className="mb-8" data-id="element-6259" data-mp="81e3q6cn8p2m">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6" data-id="element-6260" data-mp="cxmd1345to1v">
          <h1 className="text-2xl font-bold text-[#0F172A] font-heading" data-id="element-6261" data-mp="gz7z9f2l3eoq">
            {activeSubTab === 'analytiques' ? t('Tableau de bord des requêtes', 'Requests dashboard') : t('Requêtes', 'Requests')}
          </h1>
          <nav aria-label={t('Actions', 'Actions')} className="flex items-center gap-2" data-id="element-6262" data-mp="qxndwikfcvhc">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveSubTab(tab.id)} className={`px-4 py-2 text-sm font-semibold rounded-lg transition-colors ${activeSubTab === tab.id ? 'text-white bg-[#0F172A] shadow-sm hover:bg-[#1E293B]' : 'text-slate-600 bg-white border border-slate-200 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-6263" data-mp="vunlwz0u48b3">
                {tab.label}
              </button>)}
          </nav>
        </div>
      </div>

      {activeSubTab === 'analytiques' ? <RequetesAnalytics onOpenRequests={() => setActiveSubTab('gerer')} data-id="element-6264" data-mp="35sb8q65h0rtx" /> : activeSubTab === 'configurer' ? <RequetesConfigurer data-id="element-6265" data-mp="3kh7l2fek8r0c" /> : <RequetesGerer data-id="element-6266" data-mp="3fppn807u36jl" />}
    </div>;
}